define('fetch-local',[],function() {

    var fetchLocal = function(options) {
        options = options || {};

        var debugMode = options.debugMode,
            localStorage = options.localStorage,
            trainingID = options.trainingID,
            userID = options.userID;

        return new Promise(function(resolve) {
            var str,
                res = {
                    lang: null,
                    training: null,
                    user: null
                };

            if (!localStorage || !trainingID) {
                if (debugMode) {
                    if (!localStorage) {
                        window.console.log('data-context: localStorage is disabled');
                    } else {
                        window.console.log('data-context: learning not found in localStorage, missing trainingID');
                    }
                }
                resolve(res);
                return;
            }

            str = window.localStorage.getItem(trainingID);

            if (!str) {
                if (debugMode) {
                    window.console.log('data-context: learning not found in localStorage');
                }
                resolve(res);
                return;
            }

            res = window.JSON.parse(str);

            if (debugMode) {
                window.console.log('data-context: learning loaded from localStorage');
                window.console.dir(res);
            }

            userID = (userID) ? userID : (res.user && res.user.id) ? res.user.id : '';

            str = (userID) ? window.localStorage.getItem(trainingID + '-' + userID) : '';

            if (str) {
                res.user = window.JSON.parse(str);

                if (debugMode) {
                    window.console.log('data-context: user answers loaded from localStorage');
                    window.console.dir(res.user);
                }
            }

            resolve(res);
        });
    };

    return fetchLocal;
});

